<template>
  <div class="product-info-card">
    <!-- 规格参数部分 -->
    <div class="specifications-section">
      <div class="section-header specifications-header">
        <span class="header-text">规格参数</span>
      </div>
      <div class="specifications-content">
        <table class="spec-table">
          <thead>
            <tr>
              <th class="spec-column">规格</th>
              <th class="param-column">参数</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(spec, index) in specifications" :key="index">
              <td class="spec-column">{{ spec.name }}</td>
              <td class="param-column">{{ spec.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 产品信息卡片组件
 * 业务背景：用于展示产品的详细规格参数，帮助用户快速了解产品技术指标
 * 设计决策：采用表格形式展示规格参数，提升信息可读性和专业性
 */
export default {
  name: "ProductInfoCard",
  props: {
    /**
     * 规格参数列表
     * 业务背景：产品规格参数需要准确展示，通过props传入可确保数据准确性
     * 设计决策：使用数组格式，每个规格包含名称和值，便于表格渲染
     */
    specifications: {
      type: Array,
      default: () => [
        { name: "尺寸", value: "13cm*11cm*13cm, 2.3kg" },
        { name: "载玻片格式", value: "26mm*76mm*0.9mm~1.2mm（含盖玻片）" },
        { name: "图像传感器", value: "160万像素全局曝光彩色CMOS传感器" },
        { name: "分辨率", value: "0.25um/像素（20X）；0.16 µm/像素（40X）" },
        { name: "扫描模式", value: "面扫描" },
        { name: "扫描速度", value: "15mmX15mm 30秒（20X）" },
        { name: "聚焦", value: "自动聚焦" },
        { name: "多层扫描", value: "支持" },
        { name: "图像格式", value: "tiff/svs/bmp" },
        { name: "数据存储", value: "本地/云端存储" },
        { name: "供电电压", value: "12V" },
        { name: "功率", value: "约60W" },
        { name: "工作温度", value: "5°C~40°C" }
      ]
    }
  }
};
</script>

<style scoped>
/**
 * 产品信息卡片样式
 * 业务背景：需要清晰的视觉层次和良好的可读性，符合Material Design设计规范
 * 设计决策：使用绿色主题色（#7b9d38）作为强调色，白色背景，适当的阴影和间距
 */
.product-info-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 20px 0;
}

/* 区域标题样式 */
.section-header {
  padding: 12px 20px;
  background: #7b9d38;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}

.header-text {
  display: inline-block;
}

/* 规格参数区域 */
.specifications-section {
  background: #ffffff;
}

.specifications-content {
  padding: 20px;
}

/* 规格参数表格样式 */
.spec-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.spec-table thead {
  background: #f5f7fa;
}

.spec-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: bold;
  color: #333333;
  border-bottom: 2px solid #e5e5e5;
}

.spec-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e5e5;
  color: #666666;
}

.spec-table tbody tr:last-child td {
  border-bottom: none;
}

.spec-table tbody tr:hover {
  background: #f9f9f9;
}

/* 表格列宽设置 */
.spec-column {
  width: 30%;
  font-weight: 500;
  color: #333333;
}

.param-column {
  width: 70%;
  color: #666666;
}

/* 响应式设计：移动端适配 */
@media (max-width: 768px) {
  .product-info-card {
    margin: 15px 0;
    border-radius: 4px;
  }

  .section-header {
    padding: 10px 15px;
    font-size: 14px;
  }

  .specifications-content {
    padding: 15px;
  }

  .spec-table {
    font-size: 13px;
  }

  .spec-table th,
  .spec-table td {
    padding: 10px 12px;
  }

  /* 移动端表格列宽调整 */
  .spec-column {
    width: 35%;
  }

  .param-column {
    width: 65%;
  }
}

/* 打印样式优化 */
@media print {
  .product-info-card {
    box-shadow: none;
    border: 1px solid #e5e5e5;
  }

  .section-header {
    background: #7b9d38 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>

